<script lang="ts">
/**
 * Capture page — full-screen camera experience for cataloging items.
 *
 * Uses CaptureLayout (no sidebar/nav) instead of DefaultLayout.
 * Receives container context and the full container list from the
 * `Captures::ShowController` via Inertia props.
 *
 * Mobile-first: this is the primary mobile interaction for adding
 * items to inventory. Desktop falls back to a webcam view.
 */
import CaptureLayout from "@/layouts/CaptureLayout.vue"

export default { layout: CaptureLayout }
</script>

<script setup lang="ts">
import type { InertiaConfig } from "@inertiajs/core"
import { Head, usePage } from "@inertiajs/vue3"
import { computed } from "vue"

import CaptureShell from "@/components/capture/CaptureShell.vue"
import type { BreadcrumbSegment, ContainerSummary } from "@/types/models"

const props = defineProps<{
  container: ContainerSummary | null
  container_ancestors: BreadcrumbSegment[]
  recent_containers: ContainerSummary[]
  all_containers: ContainerSummary[]
  shared_images: string[] | null
}>()

const containerId = computed(() => props.container?.id ?? null)
const containerName = computed(() => props.container?.name ?? null)
const page = usePage<InertiaConfig["sharedPageProps"]>()
const accountId = computed(() => page.props.auth?.account?.id ?? "")
</script>

<template>
  <Head title="Capture" />
  <CaptureShell
    :account-id="accountId"
    :container-id="containerId"
    :container-name="containerName"
    :container-ancestors="container_ancestors"
    :recent-containers="recent_containers"
    :all-containers="all_containers"
    :shared-images="shared_images"
  />
</template>
